<div #container1 *ngIf="statesWithTasks$ | async; let data" cdkDropListGroup class="taskboard-state-column-view"
     style="overflow-x: auto;">
  <app-taskboard-column *ngFor="let map of data" [isInteractive]="isInteractive" [keyResults]="keyResults" [map]="map"
                        class="taskboard-column">

  </app-taskboard-column>
</div>
